module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-12': !_vm.selectedType, 'col-lg-4': _vm.selectedType
    }
  }, [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n                Budgetlinjer\n            ")]), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    key: _vm.tableKey,
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.filteredRows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'proposal_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.proposal_cost)) + "\n                    ")]) : (props.column.field == 'expended_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.expended_cost)) + "\n                    ")]) : (props.column.field == 'difference') ? _c('div', {
          class: {
            'good': (props.row.proposal_cost - props.row.expended_cost) > 0, 'bad': (props.row.proposal_cost - props.row.expended_cost) < 0
          },
          staticStyle: {
            "text-align": "left"
          }
        }, [((props.row.proposal_cost - props.row.expended_cost) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.proposal_cost - props.row.expended_cost)) + "\n                    ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                            Betalt\n                        ")]) : _c('span', [_vm._v("\n                            Ikke betalt\n                        ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1087789773)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)]), _vm._v(" "), (_vm.selectedType) ? _c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.selectedType) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedType = null;
        _vm.tableKey = 0
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                ")])])]) : _vm._e(), _vm._v(" "), _c('minuba-budget-report-linetypes-projecttypes', {
    attrs: {
      "type": _vm.selectedType.name,
      "rows": _vm.selectedType.project_types
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64625cd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projects/components/minubaBudgetLineTypes.vue
// module id = 885
// module chunks = 0